// src/components/ProdMgrs/components/ProdMgrsCommissionsHeader.jsx
// ============================================================================
// BLOCK PMGR.HEADER.1 — Sortable Local header clone (no changes to Commissions)
// Differences vs CommissionsHeader:
//  - Product Group -> Product Category (label + tooltip noun)
//  - Adds sorting via TableSortLabel
// ============================================================================

import React from 'react';

import InfoIcon from '@mui/icons-material/Info';

import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Tooltip from '@mui/material/Tooltip';

function SortCell({ id, label, active, direction, onClick }) {
  return (
    <TableCell variant="head">
      <TableSortLabel
        active={active}
        direction={active ? direction : 'asc'}
        onClick={() => onClick(id)}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );
}

function ProdMgrsCommissionsHeader({ isRep, sortBy, sortDir, onSort }) {
  const noun = 'Product Category';

  return (
    <TableHead>
      <TableRow>
        <SortCell
          id="InvoiceNo"
          label="Invoice"
          active={sortBy === 'InvoiceNo'}
          direction={sortDir}
          onClick={onSort}
        />
        <SortCell
          id="InvoiceDate"
          label="Invoice Date"
          active={sortBy === 'InvoiceDate'}
          direction={sortDir}
          onClick={onSort}
        />

        <TableCell variant="head">Customer</TableCell>
        <TableCell variant="head">Customer PO#</TableCell>
        <TableCell variant="head">Tracking</TableCell>
        <TableCell variant="head">State</TableCell>
        <TableCell variant="head">Area Code</TableCell>
        <TableCell variant="head">City</TableCell>
        <TableCell variant="head">Reps</TableCell>
        <TableCell variant="head">Item</TableCell>

        <SortCell
          id="ProductGroup"
          label="Product Category"
          active={sortBy === 'ProductGroup'}
          direction={sortDir}
          onClick={onSort}
        />

        <TableCell variant="head">Quantity</TableCell>
        <TableCell variant="head">Unit Price</TableCell>
        <TableCell variant="head">Sale</TableCell>
        <TableCell variant="head">Base Cost</TableCell>
        <TableCell variant="head">Contract Fee</TableCell>

        <SortCell
          id="NetSale"
          label="Net Sale"
          active={sortBy === 'NetSale'}
          direction={sortDir}
          onClick={onSort}
        />

        <TableCell variant="head">
          <Tooltip
            data-cy="running-total-tooltip"
            title={`Running sum of the Sales Total per ${noun} for the selected year`}
          >
            <span>
              <InfoIcon sx={{ fontSize: 'small' }} /> Running Total
            </span>
          </Tooltip>
        </TableCell>

        <TableCell variant="head">
          <Tooltip
            data-cy="running-net-total-tooltip"
            title={`Running sum of the Net Sales Total per ${noun} for each month`}
          >
            <span>
              <InfoIcon sx={{ fontSize: 'small' }} /> Running Net Total
            </span>
          </Tooltip>
        </TableCell>

        {isRep && (
          <>
            <SortCell
              id="CommissionRate"
              label="% Commission"
              active={sortBy === 'CommissionRate'}
              direction={sortDir}
              onClick={onSort}
            />
            <SortCell
              id="LineCommissions"
              label="Commission"
              active={sortBy === 'LineCommissions'}
              direction={sortDir}
              onClick={onSort}
            />
            <TableCell variant="head">Total Commission</TableCell>
          </>
        )}
      </TableRow>
    </TableHead>
  );
}

export default React.memo(ProdMgrsCommissionsHeader);
